import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withKeys as _withKeys, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { align: "left" }
const _hoisted_2 = { style: {"height":"800px"} }
const _hoisted_3 = { align: "left" }
const _hoisted_4 = {
  class: "card-header",
  align: "right"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { style: {"padding":"14px"} }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "bottom" }
const _hoisted_10 = { class: "time" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-upload" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode("将图片拖到此处，或"),
  /*#__PURE__*/_createElementVNode("em", null, "点击上传")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, "支持 jpg,png 格式，不超过20m", -1)

import { reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { ElMessage, ElMessageBox, ElNotification } from "element-plus";
import { getLibraryGenerateUrl } from "@/service/main/promotion/libraryGenerate";
import useClipboard from "vue-clipboard3";
import { deletePageData, editPageData, getPageListData } from "@/service/main/system";
import { usePermission } from "@/hooks/usePermission";
import store from "@/store";
import { modalConfig } from "./config/modal.config";
import { usePageModal } from "@/hooks/usePageModal";
import { useUpload } from "@/hooks/useUpload";

const pageName = 'materialLibrary';

export default /*#__PURE__*/_defineComponent({
  __name: 'MaterialLibrary',
  setup(__props) {

const treeRef = ref();
const keyword = ref('');
const nodes = ref('');
getPageListData('/main/materialLibrary/listTree', null).then(
  (res)=> {
    let empNo = store.state.login.userInfo.empNo;
    let authArr = ['zhuye', 'kongyuelian', '90000', '440091', '430175', '10846', 'fanlongxi', '10001', 'suntao', 'lifuz', '401863', '440110'];
    let auth = authArr.includes(empNo);
    if (!auth && !starCustomerAuth) {
      res.children[2].children[2].children.splice(8);
      res.children[1].children.splice(6);
    }
    nodes.value = res;
    getTree();
});

const { toClipboard } = useClipboard()

const drawer = ref(false)
const direction = ref('rtl')

const pageInfo = ref({ pageNo: 1, pageSize: 1000})
const materials = ref([])
const drawerTitle = ref(String)
const drawerNodeId = ref(Number)
const drawerClose = (done: () => void) => {
  materials.value = [];
  done();
}
const nodeClick = async (e: any, data: any)=> {
  if (data.id == 1 || !isQuery) {
    return
  }
  drawerTitle.value = data.label
  drawerNodeId.value = data.id
  drawer.value = true
  await getPageListData("/main/materialLibrary/queryByCondition", {
    type: data.id,
    materialType: 0,
    pageNo: 1,
    pageSize: 10
  }).then((res)=> {
    materials.value = res
  })
}

const filterNodeMethod = (keyword: string, node: any)=> {
  if (!keyword) return true;
  let label = node.label;
  if (label != null) {
    let match = true
    if (!node.filter) {
      match = label.indexOf(keyword) != -1;
    }
    if (match) {
      expandNode(node)
    } else {
      if (Array.isArray(node.children)){
        node.children.forEach((item: any) => {
          item.filter = false
        })
      }
    }
    return match
  } else {
    return false;
  }
}

const expandNode = (node: any) => {
  node.expand = true
  if (Array.isArray(node.children)) {
    node.children.forEach((item: any) => {
      item.filter = true
      expandNode(item)
    })
  }
}

const handleDelete = (id: number, drawerNodeId: number)=> {
  debugger
  ElMessageBox.confirm('确定删除吗', '提示', {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: 'error',
    center: true
  }).then(() => {
    deletePageData("/main/materialLibrary/" + id+"/"+drawerNodeId).then(()=>{
      getPageListData("/main/materialLibrary/queryByCondition", {
        type: drawerNodeId,
        materialType: 0,
        pageNo: 1,
        pageSize: 10
      }).then((res)=> {
        materials.value = res
      })
    })
  })
}

const handleEdit = (item: any)=> {
  getPageListData('/main/materialLibrary/detail/'+item.id,
    null).then((res)=>{
      item.types = res.nodeIds;
      type.value = item.types
      handleEditData(item);
  })
}
const onExpand = async (e: any, data: any)=> {
}
const loadData = async (node: any, resolve: any)=> {
  debugger
  const subNodes = await getPageListData('/main/materialLibrary/node/'+node.id, null);
  resolve(subNodes)
}
const router = useRouter()
const createMaterialWithNode = (t?:number)=> {
  type.value = t;
  handleNewData();
}
const createMaterial = ()=> {
  type.value = '';
  handleNewData();
}
const filter = ()=> {
  treeRef.value.filter(keyword.value);
}
const generate = async (id: string) => {
  debugger
  const url = await getLibraryGenerateUrl(id)
  try {
    await toClipboard(url)
    ElNotification({
      title: '复制成功',
      message: '快去黏贴给客户吧',
      type: 'success'
    })
  } catch (e) {
    ElNotification({
      title: '复制失败',
      message: '请等一会，复制',
      type: 'error'
    })
  }
}

const style = {
    // color: "#ffffff",
};

const isUpdate = usePermission(pageName, 'update');
const isDelete = usePermission(pageName, 'delete');
const isQuery = usePermission(pageName, 'list');
const isCreate = usePermission(pageName, 'create');
const starCustomerAuth = usePermission(pageName, 'starCustomerAuth');

const modalTitle = ref('')
const otherInfo = reactive({
  cover: '',
  materialType: 0
})
const type = ref();
const newCb = () => {
  modalTitle.value = '添加素材'
  otherInfo.cover = ''
  defaultInfo.value = {types: [type.value]};
  fileList.value = []

  files.value = []
}
const editCb = (item: any) => {
  files.value = []
  modalTitle.value = '编辑素材'
  otherInfo.cover = item.cover
  files.value.push(item.cover)
  fileList.value = [
    {
      name: 'cover' + item.cover.substring(item.cover.lastIndexOf('.')),
      url: item.cover
    }
  ]
}
const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal(
  newCb,
  editCb
)
const [uploadRef, extraData, files, action, beforeUpload, proveUpload, onSuccess, onExceed] =
  useUpload()
const fileList = ref<any[]>([])
const handleRefreshPage = () => {
  getPageListData("/main/materialLibrary/queryByCondition", {
    type: type.value,
    materialType: 0,
    pageNo: 1,
    pageSize: 10
  }).then((res)=> {
    materials.value = res
  })
  return true;
}
const handleValid = () => {
  if (files.value.length > 0) {
    otherInfo.cover = files.value[0]
  }
  return true;
}

const getTree = () => {
  modalConfig.formItems.splice(0, 1, {
      field: 'types',
      type: 'cascader',
      label: '素材分类',
      options: nodes.value.children,
      placeholder: '请搜索或选择素材分类',
      otherOptions: {
        'show-all-levels': false,
        clearable: true,
        filterable: true,
        props: {
          multiple: true,
          checkStrictly: true,
          value: 'id',
          label: 'name',
          children: 'children',
          emitPath: false
        }
    }
  })
}

const renderContent = (h: any, node: any) => {
  return h('div', [
    h('div', {class: 'tree-org-node__text', title: node.$$data.remark}, node.label)
  ]);
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_vue3_tree_org = _resolveComponent("vue3-tree-org")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_PageModal = _resolveComponent("PageModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        (_unref(isCreate))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              size: "small",
              icon: "el-icon-circle-plus-outline",
              onClick: createMaterial
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 添加素材 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createTextVNode("   "),
        _createVNode(_component_el_input, {
          type: "text",
          modelValue: keyword.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
          placeholder: "请输入搜索内容",
          onKeydown: _withKeys(filter, ["enter"]),
          clearable: "",
          style: {"width":"200px"},
          size: "small"
        }, {
          append: _withCtx(() => [
            _createVNode(_component_el_button, {
              icon: "el-icon-search",
              onClick: filter
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_vue3_tree_org, {
          ref_key: "treeRef",
          ref: treeRef,
          data: nodes.value,
          horizontal: true,
          collapsable: true,
          expandAll: true,
          "only-one-node": false,
          "default-expand-level": 2,
          "label-style": style,
          scalable: false,
          toolBar: {scale: true, restore: true, expand: true, zoom: false, fullscreen: true },
          onOnExpand: onExpand,
          onOnNodeClick: nodeClick,
          "filter-node-method": filterNodeMethod,
          "define-menus": [{name: '复制文本', command: 'copy'}],
          "node-draggable": false,
          "render-content": renderContent
        }, null, 8, ["data"])
      ])
    ]),
    _createVNode(_component_el_drawer, {
      modelValue: drawer.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((drawer).value = $event)),
      direction: direction.value,
      size: "50%",
      "before-close": drawerClose
    }, {
      title: _withCtx(() => [
        _createTextVNode(" 素材库--" + _toDisplayString(drawerTitle.value) + "    ", 1),
        _createElementVNode("span", _hoisted_3, [
          (_unref(isCreate))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                size: "medium",
                icon: "el-icon-circle-plus-outline",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (createMaterialWithNode(drawerNodeId.value)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 添加素材 ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(materials.value, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_col, {
                key: item,
                span: 5,
                offset: 1
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, {
                    "body-style": { padding: '0px'},
                    style: {"width":"160px"}
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_el_button_group, { class: "ml-4" }, {
                          default: _withCtx(() => [
                            (_unref(isUpdate))
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  type: "",
                                  size: "mini",
                                  icon: "el-icon-edit",
                                  onClick: ($event: any) => (handleEdit(item))
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            (_unref(isDelete))
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 1,
                                  type: "",
                                  size: "mini",
                                  icon: "el-icon-delete",
                                  onClick: ($event: any) => (handleDelete(item.id, drawerNodeId.value))
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _createElementVNode("a", {
                        href: item.url,
                        target: "_blank"
                      }, [
                        _createElementVNode("img", {
                          src: item.cover,
                          class: "image"
                        }, null, 8, _hoisted_6)
                      ], 8, _hoisted_5),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("a", {
                          href: item.url,
                          target: "_blank"
                        }, [
                          _createElementVNode("span", null, _toDisplayString(item.title), 1)
                        ], 8, _hoisted_8),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("time", _hoisted_10, _toDisplayString(item.createTime), 1),
                          _createVNode(_component_el_button, {
                            size: "mini",
                            type: "primary",
                            onClick: ($event: any) => (generate(item.id))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("点击复制")
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      footer: _withCtx(() => []),
      _: 1
    }, 8, ["modelValue", "direction"]),
    _createVNode(_component_PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: _unref(defaultInfo),
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      pageName: "materialLibrary",
      otherInfo: otherInfo,
      validOtherInfo: handleValid,
      refreshPage: handleRefreshPage
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_upload, {
          align: "center",
          ref_key: "uploadRef",
          ref: uploadRef,
          drag: "",
          "auto-upload": true,
          action: _unref(action),
          data: _unref(extraData),
          "file-list": fileList.value,
          "before-upload": _unref(beforeUpload),
          "list-type": "picture",
          accept: ".jpg, .jpeg, .png",
          "on-success": _unref(onSuccess),
          "on-exceed": _unref(onExceed),
          limit: 1
        }, {
          tip: _withCtx(() => [
            _hoisted_13
          ]),
          default: _withCtx(() => [
            _hoisted_11,
            _hoisted_12
          ]),
          _: 1
        }, 8, ["action", "data", "file-list", "before-upload", "on-success", "on-exceed"])
      ]),
      _: 1
    }, 8, ["defaultInfo", "modalConfig", "title", "otherInfo"])
  ], 64))
}
}

})